import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "@/components/ui/button";
import { Globe, Check, AlertCircle } from "lucide-react";

const LanguageModal = () => {
  const { 
    language, 
    changeLanguage, 
    t, 
    languages, 
    showLanguageModal, 
    closeLanguageModal 
  } = useLanguage();

  if (!showLanguageModal) return null;

  const handleSelectLanguage = (langCode) => {
    changeLanguage(langCode);
    closeLanguageModal();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={closeLanguageModal}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <Globe size={28} className="text-primary" />
          </div>
          <h2 className="text-2xl font-semibold text-primary-950 mb-1">
            {t.languageModal.title}
          </h2>
          <p className="text-muted-foreground text-sm">
            {t.languageModal.subtitle}
          </p>
        </div>

        {/* Language Options */}
        <div className="space-y-2 mb-6">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleSelectLanguage(lang.code)}
              className={`w-full flex items-center justify-between p-4 rounded-xl border-2 transition-all ${
                language === lang.code
                  ? "border-primary bg-primary/5"
                  : "border-gray-200 hover:border-primary/50 hover:bg-gray-50"
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-lg font-medium text-primary-950">
                  {lang.nativeName}
                </span>
                <span className="text-sm text-muted-foreground">
                  ({lang.name})
                </span>
              </div>
              {language === lang.code && (
                <Check size={20} className="text-primary" />
              )}
            </button>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="flex gap-3 p-4 bg-amber-50 border border-amber-200 rounded-xl mb-6">
          <AlertCircle size={20} className="text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-800">
            {t.languageModal.disclaimer}
          </p>
        </div>

        {/* Continue Button */}
        <Button
          onClick={closeLanguageModal}
          className="w-full h-11 rounded-full bg-primary hover:bg-primary-600 text-white font-medium"
        >
          {t.languageModal.continue}
        </Button>
      </div>
    </div>
  );
};

export default LanguageModal;
